'use strict'

export default base64Block => JSON.parse(decodeURIComponent(escape(atob(base64Block))))
